window.dbs = window.dbs || {}
dbs.utilities = dbs.utilities || {}

// Debounce
// See: https://davidwalsh.name/javascript-debounce-function
//
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
dbs.utilities.debounce = function (func, wait, immediate) {
  let timeout
  return function () {
    let context = this
    let args = arguments
    let later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    let callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

// Viewport units
// See: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
;(function () {
  function setVhCustomProperty() {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
  setVhCustomProperty()

  window.addEventListener('resize', dbs.utilities.debounce(setVhCustomProperty))
})()

// LazySizes
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.loadMode = 1
window.lazySizesConfig.expand = 1
window.lazySizesConfig.expFactor = 1.4
window.lazySizesConfig.hFac = 0.4
require('lazysizes')
require('lazysizes/plugins/respimg/ls.respimg')
require('lazysizes/plugins/print/ls.print')


// Font Awesome SVG Core
// See https://fontawesome.com/docs/web/dig-deeper/svg-core#comparing-the-basic-packages-and-svg-core
import { dom, library } from '@fortawesome/fontawesome-svg-core'

// Font Awesome Subsetting - Adding icons to the library
// See https://fontawesome.com/v5/docs/apis/javascript/icon-library#subsetting
import { faChevronDown as faChevronDownLight, faTimes } from '@fortawesome/pro-light-svg-icons'

import {
  faSearch,
  faFilter,
  faPauseCircle,
  faPlayCircle,
  faQuoteLeft,
  faQuoteRight,
  faInfo,
  faMapMarkerAlt,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faPlus,
  faMinus,
  faEnvelope,
  faPhone,
  faBuilding,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faCalendarAlt,
  faCheck,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faFacebook,
  faFacebookF,
  faInstagram,
  faPinterestP,
  faPinterestSquare,
  faYoutube,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'

// Add subset of icons to our library
library.add(
  faSearch,
  faFacebook,
  faFacebookF,
  faInstagram,
  faPlus,
  faMinus,
  faEnvelope,
  faPhone,
  faBuilding,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faChevronDownLight,
  faFilter,
  faPinterestP,
  faPinterestSquare,
  faYoutube,
  faTwitter,
  faPauseCircle,
  faPlayCircle,
  faTimes,
  faQuoteLeft,
  faQuoteRight,
  faInfo,
  faMapMarkerAlt,
  faCalendarAlt,
  faCheck,
)

// Font Awesome dom.i2svg(params)
// > Will automatically find any <i> tags in the page and replace those with <svg> elements.
// See https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
dom.i2svg()
